export const GET_APPRAISAL_LIST = '/building_appraisal/get_appraisal_list';
export const SHOW_APPRAISAL_DATA = '/building_appraisal/show_appraisal_data';
export const CREATE_APPRAISAL_DATA = '/building_appraisal/create_appraisal_data';
export const UPDATE_APPRAISAL_DATA = '/building_appraisal/update_appraisal_data';
export const GET_FLOOR_AREA = '/building_appraisal/get_floor_area';
export const GET_ACTUAL_USE_LIST = '/land/get_actual_use';

export const GET_APPLICATIONS_LIST = 'building/get_application_list';
export const SHOW_DATA = 'building/show_data';

export const FORM_DATA = {
    no_of_storeys: 0,
    floor_storey_areas: [],
    total_floor_area: 0,
    unit_construction_cost: 0,
    building_core_sub_total: 0,
    cost_of_additional_item_sub_total: 0,
    sub_total_adjustment: 0,
    total_construction_cost: 0,
    depreciation_rate: 0,
    depreciation_cost: 0,
    total_percent_depreciation: 0,
    market_value: 0,
};